import fetch from 'isomorphic-fetch';

const PRE_SETTINGS_URL = '/api/lineup-tool/pre-settings';

function getPackageKeyFromPath() {
    const matches = window.location.pathname.match(/\/package\/([^/]+)/);

    return matches ? matches[1] : null;
}

function parseUrl(url) {
    // Anchor parsing instead of `new URL`: there is no browserslist config, so
    // preset-env compiles for old browsers where URL is missing.
    const anchor = document.createElement('a');

    anchor.href = url;

    return anchor;
}

// Origin of the top-most frame, i.e. the hosting page even when we sit several
// frames deep. Unlike document.referrer it names that hosting page rather than
// the immediate parent, cannot be spoofed by the embedder, and survives a
// Referrer-Policy that strips the referrer. It is 'null' when the embedder opted
// out via referrerpolicy="no-referrer".
function getTopAncestorOrigin() {
    const ancestorOrigins = window.location.ancestorOrigins;

    if (!ancestorOrigins || !ancestorOrigins.length) {
        return null;
    }

    const origin = ancestorOrigins[ancestorOrigins.length - 1];

    return origin && origin !== 'null' ? origin : null;
}

// The app is embedded in an iframe by partner sites, and the API has to know
// which site is hosting it. Reported as scheme + hostname.
// Path, query and port are dropped, and cross-origin embedders are not guaranteed
// to expose more than that anyway.
function getReferrerUrl() {
    const source = getTopAncestorOrigin() || document.referrer;

    if (!source) {
        return null;
    }

    const {protocol, hostname} = parseUrl(source);

    if (!protocol || !hostname) {
        return null;
    }

    return `${protocol}//${hostname}`;
}

function buildUrl() {
    const params = {
        packageKey: getPackageKeyFromPath(),
        referrer: getReferrerUrl(),
    };

    const query = Object.keys(params)
        .filter((key) => params[key])
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

    return query ? `${PRE_SETTINGS_URL}?${query}` : PRE_SETTINGS_URL;
}

export function loadPreSettings() {
    return fetch(buildUrl(), {
            headers: {
                Accept: 'application/json',
            },
        })
        .then((response) => {
            if (response.status === 403) {
                throw new Error('Sorry. This page is not available.');
            }

            return response.json();
        })
        .then((response) => {
            window.__preSettings__ = response.data;

            return response;
        });
}

export function handleLoadPreSettingsError(error) {
    console.error('PRE_SETTINGS_ERR: ', error);

    const wrapper = document.getElementById('wrapper') || document.body;

    const message = error && error.message ? error.message : 'Something went wrong. Please try again later.';

    wrapper.textContent = message;
}
